const initialState = {

    //role List 
    loadingRoleView: false,
    roleViewDataError: "",
    roleViewData: [],
}

const LoginMasterReducer = (state = initialState, action) => {
    switch (action.type) {

        

        //role View//
        case 'FIND_ROLE_VIEW_REQUEST':
            return {
                ...state,
                loadingRoleView: true,
                roleViewData: "",
                roleViewDataError: '',
            };
        case 'FIND_ROLE_VIEW_SUCCESS':
            return {
                ...state,
                loadingRoleView: false,
                roleViewData: action.payload,
            };
        case 'FIND_ROLE_VIEW_FAILURE':
            return {
                ...state,
                loadingRoleView: false,
                roleViewDataError: action.payload,
            };
        //role View//

        default:
            return state;
    }
}

export default LoginMasterReducer;